import av01 from '../assets/avatars/avatar-profiles-01.png';
import av02 from '../assets/avatars/avatar-profiles-02.png';
import av03 from '../assets/avatars/avatar-profiles-03.png';
import av04 from '../assets/avatars/avatar-profiles-04.png';
import av05 from '../assets/avatars/avatar-profiles-05.png';
import av06 from '../assets/avatars/avatar-profiles-06.png';
import av07 from '../assets/avatars/avatar-profiles-07.png';
import av08 from '../assets/avatars/avatar-profiles-08.png';
import av09 from '../assets/avatars/avatar-profiles-09.png';
import av10 from '../assets/avatars/avatar-profiles-10.png';
import av11 from '../assets/avatars/avatar-profiles-11.png';
import av12 from '../assets/avatars/avatar-profiles-12.png';
import av13 from '../assets/avatars/avatar-profiles-13.png';
import av14 from '../assets/avatars/avatar-profiles-14.png';
import av15 from '../assets/avatars/avatar-profiles-15.png';
import av16 from '../assets/avatars/avatar-profiles-16.png';
import av17 from '../assets/avatars/avatar-profiles-17.png';
import av18 from '../assets/avatars/avatar-profiles-18.png';
import av19 from '../assets/avatars/avatar-profiles-19.png';
import av20 from '../assets/avatars/avatar-profiles-20.png';
import av21 from '../assets/avatars/avatar-profiles-21.png';
import av22 from '../assets/avatars/avatar-profiles-22.png';
import av23 from '../assets/avatars/avatar-profiles-23.png';
import av24 from '../assets/avatars/avatar-profiles-24.png';

export const AVATAR_COUNT = 24;

const AVATAR_MAP: Record<string, string> = {
  'avatar-profiles-01': av01,
  'avatar-profiles-02': av02,
  'avatar-profiles-03': av03,
  'avatar-profiles-04': av04,
  'avatar-profiles-05': av05,
  'avatar-profiles-06': av06,
  'avatar-profiles-07': av07,
  'avatar-profiles-08': av08,
  'avatar-profiles-09': av09,
  'avatar-profiles-10': av10,
  'avatar-profiles-11': av11,
  'avatar-profiles-12': av12,
  'avatar-profiles-13': av13,
  'avatar-profiles-14': av14,
  'avatar-profiles-15': av15,
  'avatar-profiles-16': av16,
  'avatar-profiles-17': av17,
  'avatar-profiles-18': av18,
  'avatar-profiles-19': av19,
  'avatar-profiles-20': av20,
  'avatar-profiles-21': av21,
  'avatar-profiles-22': av22,
  'avatar-profiles-23': av23,
  'avatar-profiles-24': av24,
};

export const ALL_AVATAR_FILENAMES = Object.keys(AVATAR_MAP);

export function avatarFilename(index: number): string {
  return `avatar-profiles-${String(index).padStart(2, '0')}`;
}

export function randomAvatarFilename(): string {
  return avatarFilename(Math.floor(Math.random() * AVATAR_COUNT) + 1);
}

export function getAvatarSrc(filename: string): string {
  if (filename.startsWith('http://') || filename.startsWith('https://')) {
    return filename;
  }
  return AVATAR_MAP[filename] ?? '';
}
